import { FormControl, Validators } from '@angular/forms';

import { UiTemplateFormContentControl, UiTemplateContentGroupRadio } from '../../../shared/model/content-template.interface';

const BuildFormControls_GroupRadio = (data: UiTemplateContentGroupRadio): UiTemplateFormContentControl[] => [
  { name: data.groupName, control: new FormControl('', [Validators.required]) },
];

export { BuildFormControls_GroupRadio };
